<template>
    <div class="print-button">
        <b-btn class="float-right" size="sm"
               @click="print()">
            <shs-icon name="print"/>
            <slot><!-- Slot for button label --></slot>
        </b-btn>
    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'

export default Vue.extend({
    name: 'PrintButton',
    props: {
        content: String,
        refs: Object,
    },
    computed: {
        inProduction () {
            return this.$api.inProduction
        }
    },
    methods: {
        print() {
            const clonedContent = this.refs[this.content].cloneNode(true)

            let section = document.getElementById('print-container')
            if (section) {
                document.body.removeChild(section)
            }
            section = document.createElement('div')
            section.id = 'print-container'
            document.body.appendChild(section)

            section.innerHTML = ''
            section.appendChild(clonedContent)
            window.print();
        }
    }
})

</script>

<style lang="scss">
.print-button {
    button.btn > svg {
        margin-left: 0 !important;
    }
}
</style>
